const SignInComponent = () => import(/*webpackChunkName: "authentication"*/ './components/auth/SignIn.vue')
const SignUpComponent = () => import(/*webpackChunkName: "authentication"*/ './components/auth/SignUp.vue')
const SignOutComponent = () => import(/*webpackChunkName: "authentication"*/ './components/auth/SignOut.vue')
const ForgotPasswordComponent = () => import(/*webpackChunkName: "authentication"*/ './components/auth/ForgotPassword.vue')
const ChangePasswordComponent = () => import(/*webpackChunkName: "authentication"*/ './components/auth/ChangePassword.vue')
const ConfirmSignupComponent = () => import(/*webpackChunkName: "authentication"*/ './components/auth/ConfirmSignUp.vue')

import AuthView from './AuthView'

const AuthRouter = {
  path: '/auth',
  name: 'auth',
  component: AuthView,
  children: [
    {
      path: 'signIn',
      name: 'auth_SignIn',
      component: SignInComponent
    },
    {
      path: 'signUp',
      name: 'auth_SignUp',
      component: SignUpComponent
    },
    {
      path: 'signOut',
      name: 'auth_SignOut',
      component: SignOutComponent
    },
    {
      path: 'confirmSignUp',
      name: 'auth_ConfirmSignUp',
      component: ConfirmSignupComponent
    },
    {
      path: 'changePassword',
      name: 'auth_Change_Password',
      component: ChangePasswordComponent
    },
    {
      path: 'forgotPassword',
      name: 'auth_ForgotPassword',
      component: ForgotPasswordComponent
    }
  ]
}

export default AuthRouter

